import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'cfarUntilAt',
})
export class CfarUntilAtPipe implements PipeTransform {
  datePipe = inject(DatePipe);

  transform(value: string, format: string) {
    const date = DateTime.fromFormat(value as string, 'yyyy-MM-dd').minus({ days: 2 });

    return this.datePipe.transform(date.toString(), format);
  }
}
